import React from 'react';
import styles from './index.module.scss';

const CList = ({ content }) => {
  return (
    <div className={styles.chatQuseListBox}>
      <div className={styles.shopDiagnosisListBox}>
        {content?.map((item, key) => {
          return (
            <div className={styles.listItem} key={key}>
              <div className={styles.titleBox}>
                <img src="https://imgcdn.sto.cn/2D85DBAE-F9B2-4D-40x40-fxdpzd.png" alt="" />
                <div className={styles.title}>{item.title}</div>
              </div>
              <div
                className={styles.ycsBox}
                style={{
                  background:
                    parseInt(item.abnormalCount) > 0 ? '#FEF4F4' : '#FAFBFC',
                  border:
                    parseInt(item.abnormalCount) > 0
                      ? '1px solid #FAE3E3'
                      : '0px',
                }}
              >
                <div className={styles.title}>异常数</div>
                <div className={styles.num}>
                  <span
                    style={{
                      color: item.abnormalCount > 0 ? '#DC444A' : '#1D2129',
                    }}
                  >
                    {item.abnormalCount}
                  </span>
                  个
                </div>
              </div>
              {item.itemList.map((item1, index1) => {
                return (
                  <div className={styles.itemList} key={index1}>
                    <div className={styles.items}>
                      <span>{index1 + 1}</span>
                      {item1.title}
                    </div>
                    <div className={styles.unit}>
                      <div className={styles.h}>{item1.abnormalCount}</div>个
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CList;
